import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectMapMoved = (state: RootState) =>
	state?.mapSettings?.mapMoved;
